import { render } from "./AddToCalendarNew.vue?vue&type=template&id=3a253d6a"
import script from "./AddToCalendarNew.vue?vue&type=script&lang=js"
export * from "./AddToCalendarNew.vue?vue&type=script&lang=js"

import "./AddToCalendarNew.vue?vue&type=style&index=0&id=3a253d6a&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__